var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"anchor-list"},_vm._l((_vm.parsedServices),function(service,index){return _c('li',{key:index},[_c('a',{attrs:{"href":service.global_service.url,"target":service.global_service.target},domProps:{"innerHTML":_vm._s(service.global_service.title)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/AnchorList.vue